import { Box, Switch, Tooltip, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React from 'react';

interface MfaProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: boolean;
}

export const Mfa = ({ onChange, value }: MfaProps) => {
  return (
    <Box marginTop="15px" display="flex" flexDirection="column" gap="5px">
      <Typography
        fontFamily="Roboto"
        fontStyle="normal"
        fontWeight="500"
        fontSize="18px"
        lineHeight="29px"
        display="flex"
        alignItems="center"
        gap="5px"
      >
        MFA - Múltiplo fator de autenticação (Recomendado)
        <Tooltip
          TransitionProps={{ style: { fontSize: '14px' } }}
          title="Aumente a segurança da sua empresa ativando o Múltiplo Fator de Autenticação. Quando ativado, todos os usuários serão solicitados a fornecer uma segunda forma de autenticação além da sua senha padrão. Isso oferece uma camada adicional de proteção para sua empresa. Por padrão, Ten Governance mantém ativado o MFA."
        >
          <HelpOutlineIcon />
        </Tooltip>
      </Typography>

      {/* <Typography textAlign="justify">
        Aumente a segurança da sua empresa ativando o <b>M</b>últiplo <b>F</b>
        ator de <b>A</b>utenticação. Quando ativado, todos os usuários serão
        solicitados a fornecer uma segunda forma de autenticação além da sua
        senha padrão. Isso oferece uma camada adicional de proteção para sua
        empresa. Por padrão, Ten Governance mantém ativado o MFA.
      </Typography> */}
      <Box>
        {/* <Typography display="flex" alignItems="center" gap="5px">
          <b>{`${value ? 'Ativado' : 'Desativado'} MFA`}</b> (Múltiplo Fator De
          Autenticação)
        </Typography> */}
        <Box display="flex" alignItems="center">
          <Typography
            fontSize="14px"
            sx={{
              fontWeight: value ? '400' : '600',
            }}
          >
            Desabilitado
          </Typography>
          <Switch checked={value} onChange={onChange} />
          <Typography
            fontSize="14px"
            sx={{
              fontWeight: value ? '600' : '400',
            }}
          >
            Habilitado
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
